import { Injectable } from "@angular/core";
import { HttpClientService } from "../../common/http-client.service";
import { Observable } from "rxjs/Rx";
import { CommonService } from "../../common/common.service";
import { Headers, RequestOptions, ResponseContentType } from "@angular/http";

@Injectable()
export class KycService {
  constructor(private http: HttpClientService, private common: CommonService) {}

  getResults(req): Observable<any> {
    return this.http.post("addMoney/search", req, 20);
  }
  getAllStatus(req): Observable<any> {
    return this.http.get("getStatusList/CSR", null, 10);
  }
  getBanksName(): Observable<any> {
    return this.http.get("getBanksName", null, 5);
  }

  updateStatus(req): Observable<any> {
    return this.http.post("addMoney/action", req, 20);
  }

  downloadSearchRecords(api, params): Observable<any> {
    let headObj: any = {
      // 'userId': this.common.getUserId(),
      Authorization: localStorage.getItem("tkn"),
    };
    let headers = new Headers(headObj);
    let reqHead = new RequestOptions({
      responseType: ResponseContentType.Blob,
      headers: headers,
    });
    return this.http.post(api, params, 20, reqHead, "blob");

    // return this.http.post(api, null, 20);
  }

  getHistory(req): Observable<any> {
    return this.http.get("addMoney/history/" + req, null, 20);
  }

  fetchData(req): Observable<any> {
    return this.http.post("userManagement/getUserInfo", req, 6);
  }
  getDetails() {
    return this.http.get("getKycType", null, 5);
  }

  multiUpload(req) {
    if (req instanceof FormData) {
      return this.http.postFile(`commonUtilities/multipart/upload`, req, 7);
    }
    return this.http.post(`commonUtilities/multipart/upload`, req, 7);
  }

  updateUser(req) {
    // return this.http.post("userManagement/updateUser", req, 0);
    return this.http.post("userManagement/updateUser", req, 7);
  }

  updateKycDetails(req) {
    // return this.http.post('transaction/userManagement/updateUser', req, 0);
    return this.http.post("userManagement/update/kyc/status", req, 7);
  }

  approveAgentStaff(req): Observable<any> {
    return this.http.put("api/v1/agent-staff/approve", req, 7);
  }

  rejectAgentStaff(req): Observable<any> {
    return this.http.put("api/v1/agent-staff/reject", req, 7);
  }

  getCount(obj) {
    const status = obj.status || "P";
    return this.http.get(`userManagement/getKycStatus/${status}?status=${status}`, null, 7);
  }

  downloadHistory(data, api) {
    let headObj: any = {
      // 'userId': this.common.getUserId(),
      Authorization: localStorage.getItem("tkn"),
    };
    let headers = new Headers(headObj);
    let reqHead = new RequestOptions({
      responseType: ResponseContentType.Blob,
      headers: headers,
    });
    return this.http.post(api, data, 20, reqHead, "blob");
  }

  downloadcsv(data, ticketId) {
    let a = document.createElement("a");
    a.setAttribute("id", "downloadCsv");
    let date = new Date();
    let Tdate =
      date.getDate() + "-" + (date.getMonth() + 1) + "-" + date.getFullYear();
    a.download = ticketId + ".csv";
    a.href = window.URL.createObjectURL(data);
    a.textContent = "Download CSV";
    a.dataset.downloadurl = [
      "text/csv;charset=ISO-8859-1",
      a.download,
      a.href,
    ].join(":");
    document.body.appendChild(a);
    setTimeout(function () {
      document.getElementById("downloadCsv").click();
      document.getElementById("downloadCsv").remove();
    }, 1000);
  }

  getEntityTypeList(id): any {
    return this.http.get("getEntityType/" + id, null, 5);
  }

  getEntitySubtype(id): any {
    return this.http.get("getEntitySubType/" + id, null, 5);
  }
  getKycResults(req): Observable<any> {
    return this.http.post("kyc/getKycDetails", req, 7);
  }
  getSegmentList(): any {
    return this.http.get("getSegmentList", null, 5);
  }
  getProvincesBySegment(segmentId: number): any {
    return this.http.get(`master/segment/${segmentId}/provinces`, null, 7);
  }
  // downloadKycSearchRecords(params):Observable<any>{

  //   let headObj: any = {
  //     'userId': this.common.getUserId(),
  //     'Authorization': localStorage.getItem('tkn')
  //   };
  //   let headers = new Headers(headObj);
  //   let reqHead = new RequestOptions({
  //       responseType: ResponseContentType.Blob,
  //       headers: headers
  //     });

  //   return this.http.post('userManagement/getKycDetailsCsv', params, 7, null, 'blob');

  //   // return this.http.post(api, null, 20);

  // }
  downloadKycSearchRecords(
    param1,
    param2,
    param3,
    param4,
    param5,
    param6,
    param7,
    param8
  ) {
    let headObj: any = {
      userId: this.common.getUserId(),
      Authorization: localStorage.getItem("tkn"),
    };
    let headers = new Headers(headObj);
    let reqHead = new RequestOptions({
      responseType: ResponseContentType.Blob,
      headers: headers,
    });

    return this.http.get(
      `userManagement/getKycDetailsCsv/` +
        param1 +
        "/" +
        param2 +
        "/" +
        param3 +
        "/" +
        param4 +
        "/" +
        param5 +
        "/" +
        param6 +
        "/" +
        param7 +
        "/" +
        param8,
      7,
      null,
      reqHead,
      "blob"
    );

    // return this.http.post(api, null, 20);
  }
}



// WEBPACK FOOTER //
// /Users/ldt/Desktop/ARES-admin-frontend/src/app/main/kyc/kyc.service.ts